import { useCallback } from 'react';
import { useTranslations } from 'next-intl';

export function useRelativeTime(namespace: string = 'users') {
  const t = useTranslations(namespace);

  return useCallback(
    (dateStr: string): string => {
      const now = new Date();
      const date = new Date(dateStr);
      const diffMs = now.getTime() - date.getTime();
      const diffSec = Math.floor(diffMs / 1000);
      const diffMin = Math.floor(diffSec / 60);
      const diffHour = Math.floor(diffMin / 60);
      const diffDay = Math.floor(diffHour / 24);

      if (diffSec < 60) return t('justNow');
      if (diffMin < 60) return t('minutesAgo', { count: diffMin });
      if (diffHour < 24) return t('hoursAgo', { count: diffHour });
      return t('daysAgo', { count: diffDay });
    },
    [t]
  );
}
